
(function ($) {
	$(document).ready(function () {


		var inputCheckVal = function () {
			var myVal = $(this).val();
			if (myVal !== '') {
				$(this).closest('.spark-field').addClass('has-val');
			} else {
				$(this).closest('.spark-field').removeClass('has-val');
			}
		}
		$('.spark-field input, .spark-field select').on('change', inputCheckVal);
		$('.spark-field input, .spark-field select').on('blur', inputCheckVal);


		$('.btn-hero').on('click', function (e) {
			e.preventDefault();
			const url = new URL(this.href);
			var hash = url.hash;
			var target = hash.substring(1);

			if ($(window).width() < 768) {

				// $( '.hero' ).addClass( 'compact-hero' );
				$('html, body').animate({
					scrollTop: 50
				}, 100);
			} else {

				$('html, body').animate({
					scrollTop: $(document.getElementsByName(target)).offset().top
				}, 800);
			}
		});

		$('.modal-link').on('click', function (e) {
			e.preventDefault();
			// launch the modal here?
		});

		let siteHeader = $( 'nav.site-header' )[0];
		siteHeader.locked = false;

		// let hasScrolled = false;
		let hasCompacted = false;
		let isTransitioning = false;
		// var teaserScrolled = function () {

		// 		var st = $(this).scrollTop();
		// 		if ( st > 40) {
		// 			$('.hero').addClass('compact-hero');
		// 		} else {
		// 			$('.hero.compact-hero').removeClass('compact-hero');
		// 		}

		// 	};
		var firstScroll = function( e ){
			console.log( 'firstScroll', this ); //eslint-disable-line
			if (hasCompacted) return;
			// Detect direction for mouse wheel (deltaY) or touch swipe
			let deltaY = e.deltaY;
			if (e.type === 'touchmove') {
				// Basic check: if moving fingers up, you are scrolling down
				deltaY = 1; 
			}

			if (deltaY > 0 && !isTransitioning) {
				isTransitioning = true;
				
				// Stop the browser from actually scrolling the page layout
				e.preventDefault(); 

				// Shrink the hero photo visually
				$('.hero').addClass('compact-hero');
				$( 'nav.site-header' ).addClass('white-header');
				window.removeEventListener('wheel', firstScroll );
				window.removeEventListener('touchmove', firstScroll );

				// Wait 600ms (matching the CSS transition) for the photo to compact, then unlock
				setTimeout(() => { scrollBackupTimer() }, 900); 
			}
		};
		var scrollBackupTimer = function() {
			console.log( 'scrollBackupTimer' ); //eslint-disable-line
			hasCompacted = true;
			isTransitioning = false;
				document.body.style.overflow = 'visible';
			
			// Kill this temporary listener entirely so normal scrolling takes over
			// $(window).off('wheel.firstScroll touchmove.firstScroll');

			
			// Start listening for the user returning to the top
			initScrollBackUpListener();
		};
		var scrollBackupCallback = function() {
			if ($(window).scrollTop() === 0 && hasCompacted) {
				hasCompacted = false;
				$('.hero').removeClass('compact-hero');
				
				// Kill the backup listener and turn the first scroll lock back on
				$(window).off('scroll');
				initCompactHeader();
				// window.addEventListener('wheel', firstScroll, { passive: false });
				// window.addEventListener('touchmove', firstScroll, { passive: false });
				// location.reload(); // Quickest way to reset layout state cleanly, or re-call the ready functions
			}
		};
		var initScrollBackUpListener = function(){
			$(window).on('scroll', scrollBackupCallback );
		};
		
		var initCompactHeader = function(){
			if ( $(window).width() < 768 ) {
				document.body.style.overflow = 'hidden';
				window.addEventListener('wheel', firstScroll, { passive: false });
				window.addEventListener('touchmove', firstScroll, { passive: false });
			}
			// $(window).on( 'scroll', this.teaserScrolled );
			// $(window).on('wheel.firstScroll touchmove.firstScroll', this.firstScroll );

		};


		/* Tower section */
		// $( window ).on( 'scroll', function(){} );
		$( window ).on('heroDone', function(){
			initCompactHeader();
			const observer = new IntersectionObserver(([entry]) => {
				if (entry.boundingClientRect.bottom <= window.innerHeight) {
					let placeholderHeight = $('#tower-image-wrap').outerHeight();
					$('#before-tower-img').css({ height: placeholderHeight })
					$('#tower-image-wrap').addClass('locked');
					$('#before-tower-img').addClass('shown');
				} else {

					$('#tower-image-wrap').removeClass('locked');
					$('#before-tower-img').removeClass('shown');
					$('#before-tower-img').css({ height: 0 });

				}
			},
				{
					threshold: [0],
				});

			const lock = document.getElementById('after-tower-img');
			observer.observe(lock);

			$('.gallery-wrap').each(function () {
				let parent = this;
				let galleryLocked = false;

				
				// when the top of the gallery reaches the top of the screen, init locking of content 
				$(this).waypoint(function (direction) {
					// console.log(parent.id + ' content hit top of window', direction); //eslint-disable-line
					if (direction == 'down') {
						$(parent).addClass('lock-content');
					} else {
						$(parent).removeClass('lock-content');
					}
				}, {
					offset: '0'
				});

				// when the gallery reveal has scrolled 30%, start fading and lock gallery to fixed to top and set height of spacer
				const targetDiv = $('.gallery-reveal', this)[0];
				const galleryDiv = $('.gallery-block', this)[0];
				const gallerySpacer = $('.gallery-spacer', this)[0];


				$( galleryDiv ).on('init', function( event, slick ){
					$( galleryDiv ).append( "<div class='gallery-caption fadeOut'></div>" );
					let caption = slick.$slides[slick.currentSlide].dataset.caption;

					$( '.gallery-caption', galleryDiv ).text( caption );
					$( '.gallery-caption', galleryDiv ).removeClass( 'fadeOut' );
				});

				$( galleryDiv ).slick({
					arrows: false,
					autoplay: true,
					autoplaySpeed: 4000,
					dots: true,
					slidesToShow: 1,
					pauseOnHover: false
				});

				$( galleryDiv ).on('beforeChange', function(){
					$( '.gallery-caption', galleryDiv ).addClass( 'fadeOut' );
				});

				$( galleryDiv ).on('afterChange', function(event, slick, currentSlide ){ 
					// console.log( slick ); // eslint-disable-line
					var caption = slick.$slides[currentSlide].dataset.caption;
					$( '.gallery-caption', galleryDiv ).text( caption );
					$( '.gallery-caption', galleryDiv ).removeClass( 'fadeOut' );
					// console.log( 'afterChange', currentSlide); // eslint-disable-line
				});
				
				let ticking = false;

				window.addEventListener('scroll', () => {
					if (!ticking) {
						window.requestAnimationFrame(() => {
							const rect = targetDiv.getBoundingClientRect();
							const viewportHeight = window.innerHeight;

							// 1. Define your shifted boundaries
							// Start fade line: when the top of the div is 20% past the top of the screen
							const fadeStartLine = -(rect.height * 0.20); 
							
							// End fade line: when the bottom of the div hits the bottom of the screen
							const fadeEndLine = viewportHeight - rect.height;
							
							// 2. Calculate the total active zone where fading actually happens
							const activeFadeDistance = fadeEndLine - fadeStartLine;
							
							// 3. Track current position relative to our new start line
							const currentPositionInZone = rect.top - fadeStartLine;
							
							// 4. Calculate progress fraction (goes from 0 to 1 inside the active zone)
							let progress = currentPositionInZone / activeFadeDistance;
							// FLIP THE MATH: Subtract from 1 so it fades OUT instead of IN
							let invertedProgress = 1 - progress;
							
							// Clamp the final value strictly between 0 and 1
							let opacity = Math.min(Math.max(invertedProgress, 0), 1);

							if ( opacity < 1 && !galleryLocked ) {
								let galleryHeight = galleryDiv.innerHeight;
								gallerySpacer.style.height = galleryHeight;
								$(parent).addClass( 'lock-gallery' );
								galleryLocked = true;
							} else if ( opacity == 1 && galleryLocked ) {
								$(parent).removeClass( 'lock-gallery' );
								galleryLocked = false;
								
							}

							// 5. Apply the opacity
							targetDiv.style.opacity = opacity;
							targetDiv.style.pointerEvents = opacity < 0.5 ? 'none' : 'all';

							ticking = false;


							// when the bottom of the gallery reveal hits the top of the screen, 
							// release the gallery to relative
			
							if (rect.bottom <= 0) {
								if ( $(parent).hasClass( 'lock-gallery' ) ) {
									$(parent).removeClass( 'lock-gallery' );
									$(parent).addClass( 'unlock-gallery' );
								} 
							} else if ( $(parent).hasClass( 'unlock-gallery' ) ) {

								$(parent).addClass( 'lock-gallery' );
								$(parent).removeClass( 'unlock-gallery' );
							}
						});
						ticking = true;
					}
				});
			});
		});
		if (!window.waitingOnTeaser) {
			$( window ).trigger( 'heroDone' );
		}
	});

})(jQuery);